const MISSING = '-';

/** A contract date for the subscription page, or a dash when the billing system has none yet. */
export const contractDateText = (date: string | null | undefined, formatDate: (date: Date) => string): string =>
	date ? formatDate(new Date(date)) : MISSING;

/** The contract term in months, or a dash when it is unknown. */
export const contractTermText = (term: number | null | undefined, monthsLabel: string): string =>
	term == null ? MISSING : `${term} ${monthsLabel}`;
